import { Button, Form, Input } from "antd";
import { Fragment, useEffect } from "react";
import { FaUserSlash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import img3 from "../../assets/img/bannerImage.png";

import { deleteAccountbymail } from "../../redux/postReducer/userPost";
import { reset } from "../../redux/Slices/userSlice";

import Footerr from "../FormHeaderAndFooter/Footerr";
import Headerr from "../FormHeaderAndFooter/Headerr";

function UserAccessRoute() {

  const { loading, error, success } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = (values) => {
    dispatch(deleteAccountbymail({ values }));
  };

useEffect(() => {
  if (error || success) {
toast.success(
  "If this email is registered, your account deletion request has been received."
);    dispatch(reset());
  }
}, [error, success, dispatch]);

  const handleNavigate = () => {
    navigate("/account/register");
  };

  return (
    <Fragment>
      <div className="container-fluid stepsform stepsform1">
        <div className="row padding-row1 cslocation forgetFPage">

          <div className="col-sm-12 loginlogo">
            <Headerr />
          </div>

          <div className="col-sm-6 forgetForm loginInputs">
            <div className="row cslocation">

              <Form
                className="login-form"
                name="deleteAccount"
                onFinish={onFinish}
                autoComplete="off"
              >
              <h3 className="main-h1">
  Delete Your Account <FaUserSlash />
</h3>

<p className="delete-info">
You can request permanent deletion of your account by entering your registered email address below. 
If your email exists in our system, we will process your deletion request.
</p>
                <div className="toTab">
                  <div className="col-sm-6 froImageBaner">
                    <img src={img3} alt="" className="bnrimgone" />
                  </div>
                </div>

                <div className="col-sm-12">
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Please input Email!",
                      },
                      {
                        type: "email",
                        message: "Enter valid email",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter your account email"
                      className="main-input-css"
                    />
                  </Form.Item>
                </div>

                <div className="col-sm-12 inLinnenee forgetPassWOrd">
                  <Button
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                    className="gstrt logBtn"
                  >
                    Send Delete Request
                  </Button>

                  <div className="tetxright">
                    <div className="Signup-css">
                      <p>
                        Don't have an account?{" "}
                        <span className="signup-btn" onClick={handleNavigate}>
                          Sign up
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

              </Form>

            </div>
          </div>

          <div className="col-sm-6 froImageBaner notTab">
            <img src={img3} alt="" className="bnrimgone" />
          </div>

          <div className="col-sm-12 noPadd">
            <Footerr />
          </div>

        </div>
      </div>
    </Fragment>
  );
}

export default UserAccessRoute;